import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface Argumentos {
    idSucursalOrigen: number;
    idSucursalDestino: number;
    idRutaOrigen?: number;
}
type Entity = Argumentos;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Argumentos
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ArgumentosComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Sucursal = getField(selectores.Sucursal);
        const Ruta = getField(selectores.Ruta);

        return (
            <div>
                {kea.autogrid(6, [
                    <Sucursal field="idSucursalOrigen" label="Origen" />,
                    <Sucursal field="idSucursalDestino" label="Destino" />,
                    <Ruta field="idRutaOrigen" label="Ruta de origen (opcional)" />
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/enrutamiento/argumento.tsx